import script from "./popup-item-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./popup-item-detail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__